"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WALLETCONNECT_DEEPLINK_CHOICE = exports.SignClient = exports.SIGN_CLIENT_VERSION = exports.SIGN_CLIENT_STORAGE_PREFIX = exports.SIGN_CLIENT_STORAGE_OPTIONS = exports.SIGN_CLIENT_PROTOCOL = exports.SIGN_CLIENT_EVENTS = exports.SIGN_CLIENT_DEFAULT = exports.SIGN_CLIENT_CONTEXT = exports.SESSION_REQUEST_EXPIRY_BOUNDARIES = exports.SESSION_EXPIRY = exports.SESSION_CONTEXT = exports.REQUEST_CONTEXT = exports.PROPOSAL_EXPIRY_MESSAGE = exports.PROPOSAL_EXPIRY = exports.PROPOSAL_CONTEXT = exports.METHODS_TO_VERIFY = exports.HISTORY_STORAGE_VERSION = exports.HISTORY_EVENTS = exports.HISTORY_CONTEXT = exports.ENGINE_RPC_OPTS = exports.ENGINE_CONTEXT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _core = require("@walletconnect/core");

var _logger = require("@walletconnect/logger");

var _types = require("@walletconnect/types");

var _utils = require("@walletconnect/utils");

var _events = _interopRequireWildcard(require("events"));

var _time = require("@walletconnect/time");

var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e9) { throw _e9; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e10) { didErr = true; err = _e10; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var j = "wc",
    J = 2,
    X = "client",
    b = "".concat(j, "@").concat(J, ":").concat(X, ":"),
    G = {
  name: X,
  logger: "error",
  controller: !1,
  relayUrl: "wss://relay.walletconnect.com"
},
    Xe = {
  session_proposal: "session_proposal",
  session_update: "session_update",
  session_extend: "session_extend",
  session_ping: "session_ping",
  session_delete: "session_delete",
  session_expire: "session_expire",
  session_request: "session_request",
  session_request_sent: "session_request_sent",
  session_event: "session_event",
  proposal_expire: "proposal_expire"
},
    He = {
  database: ":memory:"
},
    ee = "WALLETCONNECT_DEEPLINK_CHOICE",
    Fe = {
  created: "history_created",
  updated: "history_updated",
  deleted: "history_deleted",
  sync: "history_sync"
},
    Be = "history",
    We = "0.3",
    se = "proposal",
    Qe = _time.THIRTY_DAYS,
    te = "Proposal expired",
    ie = "session",
    C = _time.SEVEN_DAYS,
    ne = "engine",
    O = {
  wc_sessionPropose: {
    req: {
      ttl: _time.FIVE_MINUTES,
      prompt: !0,
      tag: 1100
    },
    res: {
      ttl: _time.FIVE_MINUTES,
      prompt: !1,
      tag: 1101
    }
  },
  wc_sessionSettle: {
    req: {
      ttl: _time.FIVE_MINUTES,
      prompt: !1,
      tag: 1102
    },
    res: {
      ttl: _time.FIVE_MINUTES,
      prompt: !1,
      tag: 1103
    }
  },
  wc_sessionUpdate: {
    req: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1104
    },
    res: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1105
    }
  },
  wc_sessionExtend: {
    req: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1106
    },
    res: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1107
    }
  },
  wc_sessionRequest: {
    req: {
      ttl: _time.FIVE_MINUTES,
      prompt: !0,
      tag: 1108
    },
    res: {
      ttl: _time.FIVE_MINUTES,
      prompt: !1,
      tag: 1109
    }
  },
  wc_sessionEvent: {
    req: {
      ttl: _time.FIVE_MINUTES,
      prompt: !0,
      tag: 1110
    },
    res: {
      ttl: _time.FIVE_MINUTES,
      prompt: !1,
      tag: 1111
    }
  },
  wc_sessionDelete: {
    req: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1112
    },
    res: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1113
    }
  },
  wc_sessionPing: {
    req: {
      ttl: _time.THIRTY_SECONDS,
      prompt: !1,
      tag: 1114
    },
    res: {
      ttl: _time.THIRTY_SECONDS,
      prompt: !1,
      tag: 1115
    }
  }
},
    $ = {
  min: _time.FIVE_MINUTES,
  max: _time.SEVEN_DAYS
},
    re = "request",
    oe = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest"];
exports.METHODS_TO_VERIFY = oe;
exports.REQUEST_CONTEXT = re;
exports.SESSION_REQUEST_EXPIRY_BOUNDARIES = $;
exports.ENGINE_RPC_OPTS = O;
exports.ENGINE_CONTEXT = ne;
exports.SESSION_EXPIRY = C;
exports.SESSION_CONTEXT = ie;
exports.PROPOSAL_EXPIRY_MESSAGE = te;
exports.PROPOSAL_EXPIRY = Qe;
exports.PROPOSAL_CONTEXT = se;
exports.HISTORY_STORAGE_VERSION = We;
exports.HISTORY_CONTEXT = Be;
exports.HISTORY_EVENTS = Fe;
exports.WALLETCONNECT_DEEPLINK_CHOICE = ee;
exports.SIGN_CLIENT_STORAGE_OPTIONS = He;
exports.SIGN_CLIENT_EVENTS = Xe;
exports.SIGN_CLIENT_DEFAULT = G;
exports.SIGN_CLIENT_STORAGE_PREFIX = b;
exports.SIGN_CLIENT_CONTEXT = X;
exports.SIGN_CLIENT_VERSION = J;
exports.SIGN_CLIENT_PROTOCOL = j;

var Ze = Object.defineProperty,
    es = Object.defineProperties,
    ss = Object.getOwnPropertyDescriptors,
    ae = Object.getOwnPropertySymbols,
    ts = Object.prototype.hasOwnProperty,
    is = Object.prototype.propertyIsEnumerable,
    ce = function ce(d, n, e) {
  return n in d ? Ze(d, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : d[n] = e;
},
    w = function w(d, n) {
  for (var e in n || (n = {})) {
    ts.call(n, e) && ce(d, e, n[e]);
  }

  if (ae) {
    var _iterator = _createForOfIteratorHelper(ae(n)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        is.call(n, e) && ce(d, e, n[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return d;
},
    H = function H(d, n) {
  return es(d, ss(n));
};

var ns = /*#__PURE__*/function (_ye) {
  _inherits(ns, _ye);

  var _super = _createSuper(ns);

  function ns(n) {
    var _this;

    _classCallCheck(this, ns);

    _this = _super.call(this, n), _this.name = ne, _this.events = new _events["default"](), _this.initialized = !1, _this.ignoredPayloadTypes = [_utils.TYPE_1], _this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this.initialized;

              if (_context.t0) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return _this.cleanup();

            case 4:
              _this.registerRelayerEvents();

              _this.registerExpirerEvents();

              _this.client.core.pairing.register({
                methods: Object.keys(O)
              });

              _this.initialized = !0;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.connect = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(e) {
        var s, t, i, r, o, a, l, h, I, _yield$_this$client$c, v, y, g, E, _T, m, V, U, _c, _v, A, le;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.isInitialized();

                s = H(w({}, e), {
                  requiredNamespaces: e.requiredNamespaces || {},
                  optionalNamespaces: e.optionalNamespaces || {}
                });
                _context3.next = 4;
                return _this.isValidConnect(s);

              case 4:
                t = s.pairingTopic, i = s.requiredNamespaces, r = s.optionalNamespaces, o = s.sessionProperties, a = s.relays;
                l = t, I = !1;

                if (!(l && (I = _this.client.core.pairing.pairings.get(l).active), !l || !I)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 9;
                return _this.client.core.pairing.create();

              case 9:
                _yield$_this$client$c = _context3.sent;
                v = _yield$_this$client$c.topic;
                y = _yield$_this$client$c.uri;
                l = v, h = y;

              case 13:
                _context3.next = 15;
                return _this.client.core.crypto.generateKeyPair();

              case 15:
                g = _context3.sent;
                E = w({
                  requiredNamespaces: i,
                  optionalNamespaces: r,
                  relays: a !== null && a !== void 0 ? a : [{
                    protocol: _core.RELAYER_DEFAULT_PROTOCOL
                  }],
                  proposer: {
                    publicKey: g,
                    metadata: _this.client.metadata
                  }
                }, o && {
                  sessionProperties: o
                });
                _T = (0, _utils.createDelayedPromise)(_time.FIVE_MINUTES, te);
                m = _T.reject;
                V = _T.resolve;
                U = _T.done;

                if (!(_this.events.once((0, _utils.engineEvent)("session_connect"), /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
                    var v, y, F;
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            v = _ref3.error, y = _ref3.session;

                            if (!v) {
                              _context2.next = 5;
                              break;
                            }

                            m(v);
                            _context2.next = 17;
                            break;

                          case 5:
                            if (!y) {
                              _context2.next = 17;
                              break;
                            }

                            y.self.publicKey = g;
                            F = H(w({}, y), {
                              requiredNamespaces: y.requiredNamespaces,
                              optionalNamespaces: y.optionalNamespaces
                            });
                            _context2.next = 10;
                            return _this.client.session.set(y.topic, F);

                          case 10:
                            _context2.next = 12;
                            return _this.setExpiry(y.topic, y.expiry);

                          case 12:
                            _context2.t0 = l;

                            if (!_context2.t0) {
                              _context2.next = 16;
                              break;
                            }

                            _context2.next = 16;
                            return _this.client.core.pairing.updateMetadata({
                              topic: l,
                              metadata: y.peer.metadata
                            });

                          case 16:
                            V(F);

                          case 17:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }()), !l)) {
                  _context3.next = 24;
                  break;
                }

                _c = (0, _utils.getInternalError)("NO_MATCHING_KEY", "connect() pairing topic: ".concat(l)), _v = _c.message;
                throw new Error(_v);

              case 24:
                _context3.next = 26;
                return _this.sendRequest(l, "wc_sessionPropose", E);

              case 26:
                A = _context3.sent;
                le = (0, _utils.calcExpiry)(_time.FIVE_MINUTES);
                _context3.next = 30;
                return _this.setProposal(A, w({
                  id: A,
                  expiry: le
                }, E));

              case 30:
                return _context3.abrupt("return", {
                  uri: h,
                  approval: U
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.pair = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4(e) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.isInitialized();

                _context4.next = 3;
                return _this.client.core.pairing.pair(e);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }(), _this.approve = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5(e) {
        var s, t, i, r, o, a, l, h, I, g, E, m, V, U;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this.isInitialized();

                _context5.next = 3;
                return _this.isValidApprove(e);

              case 3:
                s = e.id, t = e.relayProtocol, i = e.namespaces, r = e.sessionProperties, o = _this.client.proposal.get(s);
                a = o.pairingTopic, l = o.proposer, h = o.requiredNamespaces, I = o.optionalNamespaces;
                a = a || "", (0, _utils.isValidObject)(h) || (h = (0, _utils.getRequiredNamespacesFromNamespaces)(i, "approve()"));
                _context5.next = 8;
                return _this.client.core.crypto.generateKeyPair();

              case 8:
                g = _context5.sent;
                E = l.publicKey;
                _context5.next = 12;
                return _this.client.core.crypto.generateSharedKey(g, E);

              case 12:
                m = _context5.sent;
                _context5.t0 = a && s;

                if (!_context5.t0) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 17;
                return _this.client.core.pairing.updateMetadata({
                  topic: a,
                  metadata: l.metadata
                });

              case 17:
                _context5.next = 19;
                return _this.sendResult(s, a, {
                  relay: {
                    protocol: t !== null && t !== void 0 ? t : "irn"
                  },
                  responderPublicKey: g
                });

              case 19:
                _context5.next = 21;
                return _this.client.proposal["delete"](s, (0, _utils.getSdkError)("USER_DISCONNECTED"));

              case 21:
                _context5.next = 23;
                return _this.client.core.pairing.activate({
                  topic: a
                });

              case 23:
                V = w({
                  relay: {
                    protocol: t !== null && t !== void 0 ? t : "irn"
                  },
                  namespaces: i,
                  requiredNamespaces: h,
                  optionalNamespaces: I,
                  pairingTopic: a,
                  controller: {
                    publicKey: g,
                    metadata: _this.client.metadata
                  },
                  expiry: (0, _utils.calcExpiry)(C)
                }, r && {
                  sessionProperties: r
                });
                _context5.next = 26;
                return _this.client.core.relayer.subscribe(m);

              case 26:
                _context5.next = 28;
                return _this.sendRequest(m, "wc_sessionSettle", V);

              case 28:
                U = H(w({}, V), {
                  topic: m,
                  pairingTopic: a,
                  acknowledged: !1,
                  self: V.controller,
                  peer: {
                    publicKey: l.publicKey,
                    metadata: l.metadata
                  },
                  controller: g
                });
                _context5.next = 31;
                return _this.client.session.set(m, U);

              case 31:
                _context5.next = 33;
                return _this.setExpiry(m, (0, _utils.calcExpiry)(C));

              case 33:
                return _context5.abrupt("return", {
                  topic: m,
                  acknowledged: function acknowledged() {
                    return new Promise(function (A) {
                      return setTimeout(function () {
                        return A(_this.client.session.get(m));
                      }, 500);
                    });
                  }
                });

              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }(), _this.reject = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee6(e) {
        var s, t, _this$client$proposal, i;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this.isInitialized();

                _context6.next = 3;
                return _this.isValidReject(e);

              case 3:
                s = e.id, t = e.reason, _this$client$proposal = _this.client.proposal.get(s), i = _this$client$proposal.pairingTopic;
                _context6.t0 = i;

                if (!_context6.t0) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 8;
                return _this.sendError(s, i, t);

              case 8:
                _context6.next = 10;
                return _this.client.proposal["delete"](s, (0, _utils.getSdkError)("USER_DISCONNECTED"));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }(), _this.update = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee7(e) {
        var s, t, i, _T2, r, o, a;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this.isInitialized();

                _context7.next = 3;
                return _this.isValidUpdate(e);

              case 3:
                s = e.topic;
                t = e.namespaces;
                _context7.next = 7;
                return _this.sendRequest(s, "wc_sessionUpdate", {
                  namespaces: t
                });

              case 7:
                i = _context7.sent;
                _T2 = (0, _utils.createDelayedPromise)();
                r = _T2.done;
                o = _T2.resolve;
                a = _T2.reject;

                _this.events.once((0, _utils.engineEvent)("session_update", i), function (_ref9) {
                  var l = _ref9.error;
                  l ? a(l) : o();
                });

                _context7.next = 15;
                return _this.client.session.update(s, {
                  namespaces: t
                });

              case 15:
                return _context7.abrupt("return", {
                  acknowledged: r
                });

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x6) {
        return _ref8.apply(this, arguments);
      };
    }(), _this.extend = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee8(e) {
        var s, t, _T3, i, r, o;

        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this.isInitialized();

                _context8.next = 3;
                return _this.isValidExtend(e);

              case 3:
                s = e.topic;
                _context8.next = 6;
                return _this.sendRequest(s, "wc_sessionExtend", {});

              case 6:
                t = _context8.sent;
                _T3 = (0, _utils.createDelayedPromise)();
                i = _T3.done;
                r = _T3.resolve;
                o = _T3.reject;

                _this.events.once((0, _utils.engineEvent)("session_extend", t), function (_ref11) {
                  var a = _ref11.error;
                  a ? o(a) : r();
                });

                _context8.next = 14;
                return _this.setExpiry(s, (0, _utils.calcExpiry)(C));

              case 14:
                return _context8.abrupt("return", {
                  acknowledged: i
                });

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x7) {
        return _ref10.apply(this, arguments);
      };
    }(), _this.request = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee9(e) {
        var s, t, i, r, o, _T4, a, l, h, I;

        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this.isInitialized();

                _context9.next = 3;
                return _this.isValidRequest(e);

              case 3:
                s = e.chainId;
                t = e.request;
                i = e.topic;
                r = e.expiry;
                _context9.next = 9;
                return _this.sendRequest(i, "wc_sessionRequest", {
                  request: t,
                  chainId: s
                }, r);

              case 9:
                o = _context9.sent;
                _T4 = (0, _utils.createDelayedPromise)(r);
                a = _T4.done;
                l = _T4.resolve;
                h = _T4.reject;
                _this.events.once((0, _utils.engineEvent)("session_request", o), function (_ref13) {
                  var g = _ref13.error,
                      E = _ref13.result;
                  g ? h(g) : l(E);
                }), _this.client.events.emit("session_request_sent", {
                  topic: i,
                  request: t,
                  chainId: s,
                  id: o
                });
                _context9.next = 17;
                return _this.client.core.storage.getItem(ee);

              case 17:
                I = _context9.sent;
                (0, _utils.handleDeeplinkRedirect)({
                  id: o,
                  topic: i,
                  wcDeepLink: I
                });
                _context9.next = 21;
                return a();

              case 21:
                return _context9.abrupt("return", _context9.sent);

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x8) {
        return _ref12.apply(this, arguments);
      };
    }(), _this.respond = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee10(e) {
        var s, t, i;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this.isInitialized();

                _context10.next = 3;
                return _this.isValidRespond(e);

              case 3:
                s = e.topic, t = e.response, i = t.id;

                if (!(0, _jsonrpcUtils.isJsonRpcResult)(t)) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 7;
                return _this.sendResult(i, s, t.result);

              case 7:
                _context10.next = 13;
                break;

              case 9:
                _context10.t0 = (0, _jsonrpcUtils.isJsonRpcError)(t);

                if (!_context10.t0) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 13;
                return _this.sendError(i, s, t.error);

              case 13:
                _this.deletePendingSessionRequest(e.response.id, {
                  message: "fulfilled",
                  code: 0
                });

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x9) {
        return _ref14.apply(this, arguments);
      };
    }(), _this.ping = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee11(e) {
        var s, t, _T5, i, r, o;

        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this.isInitialized();

                _context11.next = 3;
                return _this.isValidPing(e);

              case 3:
                s = e.topic;

                if (!_this.client.session.keys.includes(s)) {
                  _context11.next = 17;
                  break;
                }

                _context11.next = 7;
                return _this.sendRequest(s, "wc_sessionPing", {});

              case 7:
                t = _context11.sent;
                _T5 = (0, _utils.createDelayedPromise)();
                i = _T5.done;
                r = _T5.resolve;
                o = _T5.reject;

                _this.events.once((0, _utils.engineEvent)("session_ping", t), function (_ref16) {
                  var a = _ref16.error;
                  a ? o(a) : r();
                });

                _context11.next = 15;
                return i();

              case 15:
                _context11.next = 21;
                break;

              case 17:
                _context11.t0 = _this.client.core.pairing.pairings.keys.includes(s);

                if (!_context11.t0) {
                  _context11.next = 21;
                  break;
                }

                _context11.next = 21;
                return _this.client.core.pairing.ping({
                  topic: s
                });

              case 21:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x10) {
        return _ref15.apply(this, arguments);
      };
    }(), _this.emit = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee12(e) {
        var s, t, i;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this.isInitialized();

                _context12.next = 3;
                return _this.isValidEmit(e);

              case 3:
                s = e.topic, t = e.event, i = e.chainId;
                _context12.next = 6;
                return _this.sendRequest(s, "wc_sessionEvent", {
                  event: t,
                  chainId: i
                });

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x11) {
        return _ref17.apply(this, arguments);
      };
    }(), _this.disconnect = /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee13(e) {
        var s, t, i, r;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this.isInitialized();

                _context13.next = 3;
                return _this.isValidDisconnect(e);

              case 3:
                s = e.topic;

                if (!_this.client.session.keys.includes(s)) {
                  _context13.next = 13;
                  break;
                }

                t = (0, _jsonrpcUtils.getBigIntRpcId)().toString();

                r = function r(o) {
                  (o === null || o === void 0 ? void 0 : o.id.toString()) === t && (_this.client.core.relayer.events.removeListener(_core.RELAYER_EVENTS.message_ack, r), i());
                };

                _context13.next = 9;
                return Promise.all([new Promise(function (o) {
                  i = o, _this.client.core.relayer.on(_core.RELAYER_EVENTS.message_ack, r);
                }), _this.sendRequest(s, "wc_sessionDelete", (0, _utils.getSdkError)("USER_DISCONNECTED"), void 0, t)]);

              case 9:
                _context13.next = 11;
                return _this.deleteSession(s);

              case 11:
                _context13.next = 15;
                break;

              case 13:
                _context13.next = 15;
                return _this.client.core.pairing.disconnect({
                  topic: s
                });

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x12) {
        return _ref18.apply(this, arguments);
      };
    }(), _this.find = function (e) {
      return _this.isInitialized(), _this.client.session.getAll().filter(function (s) {
        return (0, _utils.isSessionCompatible)(s, e);
      });
    }, _this.getPendingSessionRequests = function () {
      return _this.isInitialized(), _this.client.pendingRequest.getAll();
    }, _this.cleanupDuplicatePairings = /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee14(e) {
        var s, _t;

        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!e.pairingTopic) {
                  _context14.next = 14;
                  break;
                }

                _context14.prev = 1;
                s = _this.client.core.pairing.pairings.get(e.pairingTopic), _t = _this.client.core.pairing.pairings.getAll().filter(function (i) {
                  var r, o;
                  return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });

                if (!(_t.length === 0)) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return");

              case 5:
                _this.client.logger.info("Cleaning up ".concat(_t.length, " duplicate pairing(s)"));

                _context14.next = 8;
                return Promise.all(_t.map(function (i) {
                  return _this.client.core.pairing.disconnect({
                    topic: i.topic
                  });
                }));

              case 8:
                _this.client.logger.info("Duplicate pairings clean up finished");

                _context14.next = 14;
                break;

              case 11:
                _context14.prev = 11;
                _context14.t0 = _context14["catch"](1);

                _this.client.logger.error(_context14.t0);

              case 14:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[1, 11]]);
      }));

      return function (_x13) {
        return _ref19.apply(this, arguments);
      };
    }(), _this.deleteSession = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee15(e, s) {
        var _this$client$session$, t;

        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this$client$session$ = _this.client.session.get(e), t = _this$client$session$.self;
                _context15.next = 3;
                return _this.client.core.relayer.unsubscribe(e);

              case 3:
                _this.client.session["delete"](e, (0, _utils.getSdkError)("USER_DISCONNECTED"));

                _context15.t0 = _this.client.core.crypto.keychain.has(t.publicKey);

                if (!_context15.t0) {
                  _context15.next = 8;
                  break;
                }

                _context15.next = 8;
                return _this.client.core.crypto.deleteKeyPair(t.publicKey);

              case 8:
                _context15.t1 = _this.client.core.crypto.keychain.has(e);

                if (!_context15.t1) {
                  _context15.next = 12;
                  break;
                }

                _context15.next = 12;
                return _this.client.core.crypto.deleteSymKey(e);

              case 12:
                s || _this.client.core.expirer.del(e);

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x14, _x15) {
        return _ref20.apply(this, arguments);
      };
    }(), _this.deleteProposal = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee16(e, s) {
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return Promise.all([_this.client.proposal["delete"](e, (0, _utils.getSdkError)("USER_DISCONNECTED")), s ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      return function (_x16, _x17) {
        return _ref21.apply(this, arguments);
      };
    }(), _this.deletePendingSessionRequest = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee17(e, s) {
        var t,
            _args17 = arguments;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                t = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : !1;
                _context17.next = 3;
                return Promise.all([_this.client.pendingRequest["delete"](e, s), t ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x18, _x19) {
        return _ref22.apply(this, arguments);
      };
    }(), _this.setExpiry = /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee18(e, s) {
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.t0 = _this.client.session.keys.includes(e);

                if (!_context18.t0) {
                  _context18.next = 4;
                  break;
                }

                _context18.next = 4;
                return _this.client.session.update(e, {
                  expiry: s
                });

              case 4:
                _this.client.core.expirer.set(e, s);

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x20, _x21) {
        return _ref23.apply(this, arguments);
      };
    }(), _this.setProposal = /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee19(e, s) {
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return _this.client.proposal.set(e, s);

              case 2:
                _this.client.core.expirer.set(e, s.expiry);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x22, _x23) {
        return _ref24.apply(this, arguments);
      };
    }(), _this.setPendingSessionRequest = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee20(e) {
        var s, t, i, r;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                s = O.wc_sessionRequest.req.ttl, t = e.id, i = e.topic, r = e.params;
                _context20.next = 3;
                return _this.client.pendingRequest.set(t, {
                  id: t,
                  topic: i,
                  params: r
                });

              case 3:
                s && _this.client.core.expirer.set(t, (0, _utils.calcExpiry)(s));

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x24) {
        return _ref25.apply(this, arguments);
      };
    }(), _this.sendRequest = /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee21(e, s, t, i, r) {
        var o, h, a, l;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                o = (0, _jsonrpcUtils.formatJsonRpcRequest)(s, t);

                if (!((0, _utils.isBrowser)() && oe.includes(s))) {
                  _context21.next = 5;
                  break;
                }

                h = (0, _utils.hashMessage)(JSON.stringify(o));
                _context21.next = 5;
                return _this.client.core.verify.register({
                  attestationId: h
                });

              case 5:
                _context21.next = 7;
                return _this.client.core.crypto.encode(e, o);

              case 7:
                a = _context21.sent;
                l = O[s].req;
                return _context21.abrupt("return", (i && (l.ttl = i), r && (l.id = r), _this.client.core.history.set(e, o), _this.client.core.relayer.publish(e, a, l), o.id));

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x25, _x26, _x27, _x28, _x29) {
        return _ref26.apply(this, arguments);
      };
    }(), _this.sendResult = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee22(e, s, t) {
        var i, r, o, a;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                i = (0, _jsonrpcUtils.formatJsonRpcResult)(e, t);
                _context22.next = 3;
                return _this.client.core.crypto.encode(s, i);

              case 3:
                r = _context22.sent;
                _context22.next = 6;
                return _this.client.core.history.get(s, e);

              case 6:
                o = _context22.sent;
                a = O[o.request.method].res;

                _this.client.core.relayer.publish(s, r, a);

                _context22.next = 11;
                return _this.client.core.history.resolve(i);

              case 11:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x30, _x31, _x32) {
        return _ref27.apply(this, arguments);
      };
    }(), _this.sendError = /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee23(e, s, t) {
        var i, r, o, a;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                i = (0, _jsonrpcUtils.formatJsonRpcError)(e, t);
                _context23.next = 3;
                return _this.client.core.crypto.encode(s, i);

              case 3:
                r = _context23.sent;
                _context23.next = 6;
                return _this.client.core.history.get(s, e);

              case 6:
                o = _context23.sent;
                a = O[o.request.method].res;

                _this.client.core.relayer.publish(s, r, a);

                _context23.next = 11;
                return _this.client.core.history.resolve(i);

              case 11:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      return function (_x33, _x34, _x35) {
        return _ref28.apply(this, arguments);
      };
    }(), _this.cleanup = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee24() {
      var e, s;
      return _regenerator["default"].wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              e = [], s = [];

              _this.client.session.getAll().forEach(function (t) {
                (0, _utils.isExpired)(t.expiry) && e.push(t.topic);
              });

              _this.client.proposal.getAll().forEach(function (t) {
                (0, _utils.isExpired)(t.expiry) && s.push(t.id);
              });

              _context24.next = 5;
              return Promise.all([].concat(_toConsumableArray(e.map(function (t) {
                return _this.deleteSession(t);
              })), _toConsumableArray(s.map(function (t) {
                return _this.deleteProposal(t);
              }))));

            case 5:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    })), _this.onRelayEventRequest = function (e) {
      var s = e.topic,
          t = e.payload,
          i = t.method;

      switch (i) {
        case "wc_sessionPropose":
          return _this.onSessionProposeRequest(s, t);

        case "wc_sessionSettle":
          return _this.onSessionSettleRequest(s, t);

        case "wc_sessionUpdate":
          return _this.onSessionUpdateRequest(s, t);

        case "wc_sessionExtend":
          return _this.onSessionExtendRequest(s, t);

        case "wc_sessionPing":
          return _this.onSessionPingRequest(s, t);

        case "wc_sessionDelete":
          return _this.onSessionDeleteRequest(s, t);

        case "wc_sessionRequest":
          return _this.onSessionRequest(s, t);

        case "wc_sessionEvent":
          return _this.onSessionEventRequest(s, t);

        default:
          return _this.client.logger.info("Unsupported request method ".concat(i));
      }
    }, _this.onRelayEventResponse = /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee25(e) {
        var s, t, i;
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                s = e.topic;
                t = e.payload;
                _context25.next = 4;
                return _this.client.core.history.get(s, t.id);

              case 4:
                i = _context25.sent.request.method;
                _context25.t0 = i;
                _context25.next = _context25.t0 === "wc_sessionPropose" ? 8 : _context25.t0 === "wc_sessionSettle" ? 9 : _context25.t0 === "wc_sessionUpdate" ? 10 : _context25.t0 === "wc_sessionExtend" ? 11 : _context25.t0 === "wc_sessionPing" ? 12 : _context25.t0 === "wc_sessionRequest" ? 13 : 14;
                break;

              case 8:
                return _context25.abrupt("return", _this.onSessionProposeResponse(s, t));

              case 9:
                return _context25.abrupt("return", _this.onSessionSettleResponse(s, t));

              case 10:
                return _context25.abrupt("return", _this.onSessionUpdateResponse(s, t));

              case 11:
                return _context25.abrupt("return", _this.onSessionExtendResponse(s, t));

              case 12:
                return _context25.abrupt("return", _this.onSessionPingResponse(s, t));

              case 13:
                return _context25.abrupt("return", _this.onSessionRequestResponse(s, t));

              case 14:
                return _context25.abrupt("return", _this.client.logger.info("Unsupported response method ".concat(i)));

              case 15:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      return function (_x36) {
        return _ref30.apply(this, arguments);
      };
    }(), _this.onRelayEventUnknownPayload = function (e) {
      var s = e.topic,
          _c2 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "Decoded payload on topic ".concat(s, " is not identifiable as a JSON-RPC request or a response.")),
          t = _c2.message;

      throw new Error(t);
    }, _this.onSessionProposeRequest = /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee26(e, s) {
        var t, i, _r, o, a, l;

        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                t = s.params, i = s.id;
                _context26.prev = 1;

                _this.isValidConnect(w({}, s.params));

                _r = (0, _utils.calcExpiry)(_time.FIVE_MINUTES), o = w({
                  id: i,
                  pairingTopic: e,
                  expiry: _r
                }, t);
                _context26.next = 6;
                return _this.setProposal(i, o);

              case 6:
                a = (0, _utils.hashMessage)(JSON.stringify(s));
                _context26.next = 9;
                return _this.getVerifyContext(a, o.proposer.metadata);

              case 9:
                l = _context26.sent;

                _this.client.events.emit("session_proposal", {
                  id: i,
                  params: o,
                  verifyContext: l
                });

                _context26.next = 18;
                break;

              case 13:
                _context26.prev = 13;
                _context26.t0 = _context26["catch"](1);
                _context26.next = 17;
                return _this.sendError(i, e, _context26.t0);

              case 17:
                _this.client.logger.error(_context26.t0);

              case 18:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[1, 13]]);
      }));

      return function (_x37, _x38) {
        return _ref31.apply(this, arguments);
      };
    }(), _this.onSessionProposeResponse = /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee27(e, s) {
        var t, _i, _r2, o, a, l, h;

        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                t = s.id;

                if (!(0, _jsonrpcUtils.isJsonRpcResult)(s)) {
                  _context27.next = 22;
                  break;
                }

                _i = s.result;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  result: _i
                });

                _r2 = _this.client.proposal.get(t);

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  proposal: _r2
                });

                o = _r2.proposer.publicKey;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  selfPublicKey: o
                });

                a = _i.responderPublicKey;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  peerPublicKey: a
                });

                _context27.next = 12;
                return _this.client.core.crypto.generateSharedKey(o, a);

              case 12:
                l = _context27.sent;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  sessionTopic: l
                });

                _context27.next = 16;
                return _this.client.core.relayer.subscribe(l);

              case 16:
                h = _context27.sent;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  subscriptionId: h
                });

                _context27.next = 20;
                return _this.client.core.pairing.activate({
                  topic: e
                });

              case 20:
                _context27.next = 27;
                break;

              case 22:
                _context27.t0 = (0, _jsonrpcUtils.isJsonRpcError)(s);

                if (!_context27.t0) {
                  _context27.next = 27;
                  break;
                }

                _context27.next = 26;
                return _this.client.proposal["delete"](t, (0, _utils.getSdkError)("USER_DISCONNECTED"));

              case 26:
                _this.events.emit((0, _utils.engineEvent)("session_connect"), {
                  error: s.error
                });

              case 27:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      return function (_x39, _x40) {
        return _ref32.apply(this, arguments);
      };
    }(), _this.onSessionSettleRequest = /*#__PURE__*/function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee28(e, s) {
        var t, i, _s$params, _r3, o, a, l, h, I, g, E, m;

        return _regenerator["default"].wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                t = s.id, i = s.params;
                _context28.prev = 1;

                _this.isValidSessionSettleRequest(i);

                _s$params = s.params, _r3 = _s$params.relay, o = _s$params.controller, a = _s$params.expiry, l = _s$params.namespaces, h = _s$params.requiredNamespaces, I = _s$params.optionalNamespaces, g = _s$params.sessionProperties, E = _s$params.pairingTopic, m = w({
                  topic: e,
                  relay: _r3,
                  expiry: a,
                  namespaces: l,
                  acknowledged: !0,
                  pairingTopic: E,
                  requiredNamespaces: h,
                  optionalNamespaces: I,
                  controller: o.publicKey,
                  self: {
                    publicKey: "",
                    metadata: _this.client.metadata
                  },
                  peer: {
                    publicKey: o.publicKey,
                    metadata: o.metadata
                  }
                }, g && {
                  sessionProperties: g
                });
                _context28.next = 6;
                return _this.sendResult(s.id, e, !0);

              case 6:
                _this.events.emit((0, _utils.engineEvent)("session_connect"), {
                  session: m
                });

                _this.cleanupDuplicatePairings(m);

                _context28.next = 15;
                break;

              case 10:
                _context28.prev = 10;
                _context28.t0 = _context28["catch"](1);
                _context28.next = 14;
                return _this.sendError(t, e, _context28.t0);

              case 14:
                _this.client.logger.error(_context28.t0);

              case 15:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, null, [[1, 10]]);
      }));

      return function (_x41, _x42) {
        return _ref33.apply(this, arguments);
      };
    }(), _this.onSessionSettleResponse = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee29(e, s) {
        var t;
        return _regenerator["default"].wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                t = s.id;

                if (!(0, _jsonrpcUtils.isJsonRpcResult)(s)) {
                  _context29.next = 7;
                  break;
                }

                _context29.next = 4;
                return _this.client.session.update(e, {
                  acknowledged: !0
                });

              case 4:
                _this.events.emit((0, _utils.engineEvent)("session_approve", t), {});

                _context29.next = 12;
                break;

              case 7:
                _context29.t0 = (0, _jsonrpcUtils.isJsonRpcError)(s);

                if (!_context29.t0) {
                  _context29.next = 12;
                  break;
                }

                _context29.next = 11;
                return _this.client.session["delete"](e, (0, _utils.getSdkError)("USER_DISCONNECTED"));

              case 11:
                _this.events.emit((0, _utils.engineEvent)("session_approve", t), {
                  error: s.error
                });

              case 12:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      return function (_x43, _x44) {
        return _ref34.apply(this, arguments);
      };
    }(), _this.onSessionUpdateRequest = /*#__PURE__*/function () {
      var _ref35 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee30(e, s) {
        var t, i;
        return _regenerator["default"].wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                t = s.params, i = s.id;
                _context30.prev = 1;

                _this.isValidUpdate(w({
                  topic: e
                }, t));

                _context30.next = 5;
                return _this.client.session.update(e, {
                  namespaces: t.namespaces
                });

              case 5:
                _context30.next = 7;
                return _this.sendResult(i, e, !0);

              case 7:
                _this.client.events.emit("session_update", {
                  id: i,
                  topic: e,
                  params: t
                });

                _context30.next = 15;
                break;

              case 10:
                _context30.prev = 10;
                _context30.t0 = _context30["catch"](1);
                _context30.next = 14;
                return _this.sendError(i, e, _context30.t0);

              case 14:
                _this.client.logger.error(_context30.t0);

              case 15:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, null, [[1, 10]]);
      }));

      return function (_x45, _x46) {
        return _ref35.apply(this, arguments);
      };
    }(), _this.onSessionUpdateResponse = function (e, s) {
      var t = s.id;
      (0, _jsonrpcUtils.isJsonRpcResult)(s) ? _this.events.emit((0, _utils.engineEvent)("session_update", t), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && _this.events.emit((0, _utils.engineEvent)("session_update", t), {
        error: s.error
      });
    }, _this.onSessionExtendRequest = /*#__PURE__*/function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee31(e, s) {
        var t;
        return _regenerator["default"].wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                t = s.id;
                _context31.prev = 1;

                _this.isValidExtend({
                  topic: e
                });

                _context31.next = 5;
                return _this.setExpiry(e, (0, _utils.calcExpiry)(C));

              case 5:
                _context31.next = 7;
                return _this.sendResult(t, e, !0);

              case 7:
                _this.client.events.emit("session_extend", {
                  id: t,
                  topic: e
                });

                _context31.next = 15;
                break;

              case 10:
                _context31.prev = 10;
                _context31.t0 = _context31["catch"](1);
                _context31.next = 14;
                return _this.sendError(t, e, _context31.t0);

              case 14:
                _this.client.logger.error(_context31.t0);

              case 15:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, null, [[1, 10]]);
      }));

      return function (_x47, _x48) {
        return _ref36.apply(this, arguments);
      };
    }(), _this.onSessionExtendResponse = function (e, s) {
      var t = s.id;
      (0, _jsonrpcUtils.isJsonRpcResult)(s) ? _this.events.emit((0, _utils.engineEvent)("session_extend", t), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && _this.events.emit((0, _utils.engineEvent)("session_extend", t), {
        error: s.error
      });
    }, _this.onSessionPingRequest = /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee32(e, s) {
        var t;
        return _regenerator["default"].wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                t = s.id;
                _context32.prev = 1;

                _this.isValidPing({
                  topic: e
                });

                _context32.next = 5;
                return _this.sendResult(t, e, !0);

              case 5:
                _this.client.events.emit("session_ping", {
                  id: t,
                  topic: e
                });

                _context32.next = 13;
                break;

              case 8:
                _context32.prev = 8;
                _context32.t0 = _context32["catch"](1);
                _context32.next = 12;
                return _this.sendError(t, e, _context32.t0);

              case 12:
                _this.client.logger.error(_context32.t0);

              case 13:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, null, [[1, 8]]);
      }));

      return function (_x49, _x50) {
        return _ref37.apply(this, arguments);
      };
    }(), _this.onSessionPingResponse = function (e, s) {
      var t = s.id;
      setTimeout(function () {
        (0, _jsonrpcUtils.isJsonRpcResult)(s) ? _this.events.emit((0, _utils.engineEvent)("session_ping", t), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && _this.events.emit((0, _utils.engineEvent)("session_ping", t), {
          error: s.error
        });
      }, 500);
    }, _this.onSessionDeleteRequest = /*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee34(e, s) {
        var t;
        return _regenerator["default"].wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                t = s.id;
                _context34.prev = 1;

                _this.isValidDisconnect({
                  topic: e,
                  reason: s.params
                });

                _context34.next = 5;
                return Promise.all([new Promise(function (i) {
                  _this.client.core.relayer.once(_core.RELAYER_EVENTS.publish, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee33() {
                    return _regenerator["default"].wrap(function _callee33$(_context33) {
                      while (1) {
                        switch (_context33.prev = _context33.next) {
                          case 0:
                            _context33.t0 = i;
                            _context33.next = 3;
                            return _this.deleteSession(e);

                          case 3:
                            _context33.t1 = _context33.sent;
                            (0, _context33.t0)(_context33.t1);

                          case 5:
                          case "end":
                            return _context33.stop();
                        }
                      }
                    }, _callee33);
                  })));
                }), _this.sendResult(t, e, !0)]);

              case 5:
                _this.client.events.emit("session_delete", {
                  id: t,
                  topic: e
                });

                _context34.next = 11;
                break;

              case 8:
                _context34.prev = 8;
                _context34.t0 = _context34["catch"](1);

                _this.client.logger.error(_context34.t0);

              case 11:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, null, [[1, 8]]);
      }));

      return function (_x51, _x52) {
        return _ref38.apply(this, arguments);
      };
    }(), _this.onSessionRequest = /*#__PURE__*/function () {
      var _ref40 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee35(e, s) {
        var t, i, _r4, o, a;

        return _regenerator["default"].wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                t = s.id, i = s.params;
                _context35.prev = 1;

                _this.isValidRequest(w({
                  topic: e
                }, i));

                _context35.next = 5;
                return _this.setPendingSessionRequest({
                  id: t,
                  topic: e,
                  params: i
                });

              case 5:
                _r4 = (0, _utils.hashMessage)(JSON.stringify(s));
                o = _this.client.session.get(e);
                _context35.next = 9;
                return _this.getVerifyContext(_r4, o.peer.metadata);

              case 9:
                a = _context35.sent;

                _this.client.events.emit("session_request", {
                  id: t,
                  topic: e,
                  params: i,
                  verifyContext: a
                });

                _context35.next = 18;
                break;

              case 13:
                _context35.prev = 13;
                _context35.t0 = _context35["catch"](1);
                _context35.next = 17;
                return _this.sendError(t, e, _context35.t0);

              case 17:
                _this.client.logger.error(_context35.t0);

              case 18:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, null, [[1, 13]]);
      }));

      return function (_x53, _x54) {
        return _ref40.apply(this, arguments);
      };
    }(), _this.onSessionRequestResponse = function (e, s) {
      var t = s.id;
      (0, _jsonrpcUtils.isJsonRpcResult)(s) ? _this.events.emit((0, _utils.engineEvent)("session_request", t), {
        result: s.result
      }) : (0, _jsonrpcUtils.isJsonRpcError)(s) && _this.events.emit((0, _utils.engineEvent)("session_request", t), {
        error: s.error
      });
    }, _this.onSessionEventRequest = /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee36(e, s) {
        var t, i;
        return _regenerator["default"].wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                t = s.id, i = s.params;
                _context36.prev = 1;
                _this.isValidEmit(w({
                  topic: e
                }, i)), _this.client.events.emit("session_event", {
                  id: t,
                  topic: e,
                  params: i
                });
                _context36.next = 10;
                break;

              case 5:
                _context36.prev = 5;
                _context36.t0 = _context36["catch"](1);
                _context36.next = 9;
                return _this.sendError(t, e, _context36.t0);

              case 9:
                _this.client.logger.error(_context36.t0);

              case 10:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, null, [[1, 5]]);
      }));

      return function (_x55, _x56) {
        return _ref41.apply(this, arguments);
      };
    }(), _this.isValidConnect = /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee37(e) {
        var _c3, a, s, t, i, r, o, _c4, _a;

        return _regenerator["default"].wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context37.next = 3;
                  break;
                }

                _c3 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "connect() params: ".concat(JSON.stringify(e))), a = _c3.message;
                throw new Error(a);

              case 3:
                s = e.pairingTopic, t = e.requiredNamespaces, i = e.optionalNamespaces, r = e.sessionProperties, o = e.relays;
                _context37.t0 = (0, _utils.isUndefined)(s);

                if (_context37.t0) {
                  _context37.next = 8;
                  break;
                }

                _context37.next = 8;
                return _this.isValidPairingTopic(s);

              case 8:
                if ((0, _utils.isValidRelays)(o, !0)) {
                  _context37.next = 11;
                  break;
                }

                _c4 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "connect() relays: ".concat(o)), _a = _c4.message;
                throw new Error(_a);

              case 11:
                !(0, _utils.isUndefined)(t) && (0, _utils.isValidObject)(t) !== 0 && _this.validateNamespaces(t, "requiredNamespaces"), !(0, _utils.isUndefined)(i) && (0, _utils.isValidObject)(i) !== 0 && _this.validateNamespaces(i, "optionalNamespaces"), (0, _utils.isUndefined)(r) || _this.validateSessionProps(r, "sessionProperties");

              case 12:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      return function (_x57) {
        return _ref42.apply(this, arguments);
      };
    }(), _this.validateNamespaces = function (e, s) {
      var t = (0, _utils.isValidRequiredNamespaces)(e, "connect()", s);
      if (t) throw new Error(t.message);
    }, _this.isValidApprove = /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee38(e) {
        var s, t, i, r, o, a, l, _c5, h;

        return _regenerator["default"].wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context38.next = 2;
                  break;
                }

                throw new Error((0, _utils.getInternalError)("MISSING_OR_INVALID", "approve() params: ".concat(e)).message);

              case 2:
                s = e.id, t = e.namespaces, i = e.relayProtocol, r = e.sessionProperties;
                _context38.next = 5;
                return _this.isValidProposalId(s);

              case 5:
                o = _this.client.proposal.get(s), a = (0, _utils.isValidNamespaces)(t, "approve()");

                if (!a) {
                  _context38.next = 8;
                  break;
                }

                throw new Error(a.message);

              case 8:
                l = (0, _utils.isConformingNamespaces)(o.requiredNamespaces, t, "approve()");

                if (!l) {
                  _context38.next = 11;
                  break;
                }

                throw new Error(l.message);

              case 11:
                if ((0, _utils.isValidString)(i, !0)) {
                  _context38.next = 14;
                  break;
                }

                _c5 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "approve() relayProtocol: ".concat(i)), h = _c5.message;
                throw new Error(h);

              case 14:
                (0, _utils.isUndefined)(r) || _this.validateSessionProps(r, "sessionProperties");

              case 15:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      return function (_x58) {
        return _ref43.apply(this, arguments);
      };
    }(), _this.isValidReject = /*#__PURE__*/function () {
      var _ref44 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee39(e) {
        var _c6, _i2, s, t, _c7, _i3;

        return _regenerator["default"].wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context39.next = 3;
                  break;
                }

                _c6 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "reject() params: ".concat(e)), _i2 = _c6.message;
                throw new Error(_i2);

              case 3:
                s = e.id, t = e.reason;
                _context39.next = 6;
                return _this.isValidProposalId(s);

              case 6:
                if ((0, _utils.isValidErrorReason)(t)) {
                  _context39.next = 9;
                  break;
                }

                _c7 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "reject() reason: ".concat(JSON.stringify(t))), _i3 = _c7.message;
                throw new Error(_i3);

              case 9:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));

      return function (_x59) {
        return _ref44.apply(this, arguments);
      };
    }(), _this.isValidSessionSettleRequest = function (e) {
      if (!(0, _utils.isValidParams)(e)) {
        var _c8 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() params: ".concat(e)),
            l = _c8.message;

        throw new Error(l);
      }

      var s = e.relay,
          t = e.controller,
          i = e.namespaces,
          r = e.expiry;

      if (!(0, _utils.isValidRelay)(s)) {
        var _c9 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string"),
            _l = _c9.message;

        throw new Error(_l);
      }

      var o = (0, _utils.isValidController)(t, "onSessionSettleRequest()");
      if (o) throw new Error(o.message);
      var a = (0, _utils.isValidNamespaces)(i, "onSessionSettleRequest()");
      if (a) throw new Error(a.message);

      if ((0, _utils.isExpired)(r)) {
        var _c10 = (0, _utils.getInternalError)("EXPIRED", "onSessionSettleRequest()"),
            _l2 = _c10.message;

        throw new Error(_l2);
      }
    }, _this.isValidUpdate = /*#__PURE__*/function () {
      var _ref45 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee40(e) {
        var _c11, a, s, t, i, r, o;

        return _regenerator["default"].wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context40.next = 3;
                  break;
                }

                _c11 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "update() params: ".concat(e)), a = _c11.message;
                throw new Error(a);

              case 3:
                s = e.topic, t = e.namespaces;
                _context40.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                i = _this.client.session.get(s), r = (0, _utils.isValidNamespaces)(t, "update()");

                if (!r) {
                  _context40.next = 9;
                  break;
                }

                throw new Error(r.message);

              case 9:
                o = (0, _utils.isConformingNamespaces)(i.requiredNamespaces, t, "update()");

                if (!o) {
                  _context40.next = 12;
                  break;
                }

                throw new Error(o.message);

              case 12:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));

      return function (_x60) {
        return _ref45.apply(this, arguments);
      };
    }(), _this.isValidExtend = /*#__PURE__*/function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee41(e) {
        var _c12, _t2, s;

        return _regenerator["default"].wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context41.next = 3;
                  break;
                }

                _c12 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "extend() params: ".concat(e)), _t2 = _c12.message;
                throw new Error(_t2);

              case 3:
                s = e.topic;
                _context41.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41);
      }));

      return function (_x61) {
        return _ref46.apply(this, arguments);
      };
    }(), _this.isValidRequest = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee42(e) {
        var _c13, a, s, t, i, r, _this$client$session$2, o, _c14, _a2, _c15, _a3, _c16, _a4, _c17, _a5;

        return _regenerator["default"].wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context42.next = 3;
                  break;
                }

                _c13 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "request() params: ".concat(e)), a = _c13.message;
                throw new Error(a);

              case 3:
                s = e.topic, t = e.request, i = e.chainId, r = e.expiry;
                _context42.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                _this$client$session$2 = _this.client.session.get(s), o = _this$client$session$2.namespaces;

                if ((0, _utils.isValidNamespacesChainId)(o, i)) {
                  _context42.next = 10;
                  break;
                }

                _c14 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "request() chainId: ".concat(i)), _a2 = _c14.message;
                throw new Error(_a2);

              case 10:
                if ((0, _utils.isValidRequest)(t)) {
                  _context42.next = 13;
                  break;
                }

                _c15 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "request() ".concat(JSON.stringify(t))), _a3 = _c15.message;
                throw new Error(_a3);

              case 13:
                if ((0, _utils.isValidNamespacesRequest)(o, i, t.method)) {
                  _context42.next = 16;
                  break;
                }

                _c16 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "request() method: ".concat(t.method)), _a4 = _c16.message;
                throw new Error(_a4);

              case 16:
                if (!(r && !(0, _utils.isValidRequestExpiry)(r, $))) {
                  _context42.next = 19;
                  break;
                }

                _c17 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "request() expiry: ".concat(r, ". Expiry must be a number (in seconds) between ").concat($.min, " and ").concat($.max)), _a5 = _c17.message;
                throw new Error(_a5);

              case 19:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));

      return function (_x62) {
        return _ref47.apply(this, arguments);
      };
    }(), _this.isValidRespond = /*#__PURE__*/function () {
      var _ref48 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee43(e) {
        var _c18, _i4, s, t, _c19, _i5;

        return _regenerator["default"].wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context43.next = 3;
                  break;
                }

                _c18 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "respond() params: ".concat(e)), _i4 = _c18.message;
                throw new Error(_i4);

              case 3:
                s = e.topic, t = e.response;
                _context43.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                if ((0, _utils.isValidResponse)(t)) {
                  _context43.next = 9;
                  break;
                }

                _c19 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "respond() response: ".concat(JSON.stringify(t))), _i5 = _c19.message;
                throw new Error(_i5);

              case 9:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      return function (_x63) {
        return _ref48.apply(this, arguments);
      };
    }(), _this.isValidPing = /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee44(e) {
        var _c20, _t3, s;

        return _regenerator["default"].wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context44.next = 3;
                  break;
                }

                _c20 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "ping() params: ".concat(e)), _t3 = _c20.message;
                throw new Error(_t3);

              case 3:
                s = e.topic;
                _context44.next = 6;
                return _this.isValidSessionOrPairingTopic(s);

              case 6:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      return function (_x64) {
        return _ref49.apply(this, arguments);
      };
    }(), _this.isValidEmit = /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee45(e) {
        var _c21, o, s, t, i, _this$client$session$3, r, _c22, _o, _c23, _o2, _c24, _o3;

        return _regenerator["default"].wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context45.next = 3;
                  break;
                }

                _c21 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "emit() params: ".concat(e)), o = _c21.message;
                throw new Error(o);

              case 3:
                s = e.topic, t = e.event, i = e.chainId;
                _context45.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                _this$client$session$3 = _this.client.session.get(s), r = _this$client$session$3.namespaces;

                if ((0, _utils.isValidNamespacesChainId)(r, i)) {
                  _context45.next = 10;
                  break;
                }

                _c22 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "emit() chainId: ".concat(i)), _o = _c22.message;
                throw new Error(_o);

              case 10:
                if ((0, _utils.isValidEvent)(t)) {
                  _context45.next = 13;
                  break;
                }

                _c23 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(t))), _o2 = _c23.message;
                throw new Error(_o2);

              case 13:
                if ((0, _utils.isValidNamespacesEvent)(r, i, t.name)) {
                  _context45.next = 16;
                  break;
                }

                _c24 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(t))), _o3 = _c24.message;
                throw new Error(_o3);

              case 16:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));

      return function (_x65) {
        return _ref50.apply(this, arguments);
      };
    }(), _this.isValidDisconnect = /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee46(e) {
        var _c25, _t4, s;

        return _regenerator["default"].wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                if ((0, _utils.isValidParams)(e)) {
                  _context46.next = 3;
                  break;
                }

                _c25 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "disconnect() params: ".concat(e)), _t4 = _c25.message;
                throw new Error(_t4);

              case 3:
                s = e.topic;
                _context46.next = 6;
                return _this.isValidSessionOrPairingTopic(s);

              case 6:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));

      return function (_x66) {
        return _ref51.apply(this, arguments);
      };
    }(), _this.getVerifyContext = /*#__PURE__*/function () {
      var _ref52 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee47(e, s) {
        var t, _i6;

        return _regenerator["default"].wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                t = {
                  verified: {
                    verifyUrl: s.verifyUrl || "",
                    validation: "UNKNOWN",
                    origin: s.url || ""
                  }
                };
                _context47.prev = 1;
                _context47.next = 4;
                return _this.client.core.verify.resolve({
                  attestationId: e,
                  verifyUrl: s.verifyUrl
                });

              case 4:
                _i6 = _context47.sent;
                _i6 && (t.verified.origin = _i6, t.verified.validation = _i6 === s.url ? "VALID" : "INVALID");
                _context47.next = 11;
                break;

              case 8:
                _context47.prev = 8;
                _context47.t0 = _context47["catch"](1);

                _this.client.logger.error(_context47.t0);

              case 11:
                return _context47.abrupt("return", (_this.client.logger.info("Verify context: ".concat(JSON.stringify(t))), t));

              case 12:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, null, [[1, 8]]);
      }));

      return function (_x67, _x68) {
        return _ref52.apply(this, arguments);
      };
    }(), _this.validateSessionProps = function (e, s) {
      Object.values(e).forEach(function (t) {
        if (!(0, _utils.isValidString)(t, !1)) {
          var _c26 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "".concat(s, " must be in Record<string, string> format. Received: ").concat(JSON.stringify(t))),
              _i7 = _c26.message;

          throw new Error(_i7);
        }
      });
    };
    return _this;
  }

  _createClass(ns, [{
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c27 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            n = _c27.message;

        throw new Error(n);
      }
    }
  }, {
    key: "registerRelayerEvents",
    value: function registerRelayerEvents() {
      var _this2 = this;

      this.client.core.relayer.on(_core.RELAYER_EVENTS.message, /*#__PURE__*/function () {
        var _ref53 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee48(n) {
          var e, s, t;
          return _regenerator["default"].wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  e = n.topic, s = n.message;

                  if (!_this2.ignoredPayloadTypes.includes(_this2.client.core.crypto.getPayloadType(s))) {
                    _context48.next = 3;
                    break;
                  }

                  return _context48.abrupt("return");

                case 3:
                  _context48.next = 5;
                  return _this2.client.core.crypto.decode(e, s);

                case 5:
                  t = _context48.sent;

                  if (!(0, _jsonrpcUtils.isJsonRpcRequest)(t)) {
                    _context48.next = 10;
                    break;
                  }

                  _this2.client.core.history.set(e, t), _this2.onRelayEventRequest({
                    topic: e,
                    payload: t
                  });
                  _context48.next = 17;
                  break;

                case 10:
                  if (!(0, _jsonrpcUtils.isJsonRpcResponse)(t)) {
                    _context48.next = 16;
                    break;
                  }

                  _context48.next = 13;
                  return _this2.client.core.history.resolve(t);

                case 13:
                  _this2.onRelayEventResponse({
                    topic: e,
                    payload: t
                  });

                  _context48.next = 17;
                  break;

                case 16:
                  _this2.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                  });

                case 17:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48);
        }));

        return function (_x69) {
          return _ref53.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerExpirerEvents",
    value: function registerExpirerEvents() {
      var _this3 = this;

      this.client.core.expirer.on(_core.EXPIRER_EVENTS.expired, /*#__PURE__*/function () {
        var _ref54 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee49(n) {
          var _Le, e, s;

          return _regenerator["default"].wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  _Le = (0, _utils.parseExpirerTarget)(n.target), e = _Le.topic, s = _Le.id;

                  if (!(s && _this3.client.pendingRequest.keys.includes(s))) {
                    _context49.next = 5;
                    break;
                  }

                  _context49.next = 4;
                  return _this3.deletePendingSessionRequest(s, (0, _utils.getInternalError)("EXPIRED"), !0);

                case 4:
                  return _context49.abrupt("return", _context49.sent);

                case 5:
                  if (!e) {
                    _context49.next = 13;
                    break;
                  }

                  _context49.t0 = _this3.client.session.keys.includes(e);

                  if (!_context49.t0) {
                    _context49.next = 11;
                    break;
                  }

                  _context49.next = 10;
                  return _this3.deleteSession(e, !0);

                case 10:
                  _this3.client.events.emit("session_expire", {
                    topic: e
                  });

                case 11:
                  _context49.next = 18;
                  break;

                case 13:
                  _context49.t1 = s;

                  if (!_context49.t1) {
                    _context49.next = 18;
                    break;
                  }

                  _context49.next = 17;
                  return _this3.deleteProposal(s, !0);

                case 17:
                  _this3.client.events.emit("proposal_expire", {
                    id: s
                  });

                case 18:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49);
        }));

        return function (_x70) {
          return _ref54.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "isValidPairingTopic",
    value: function isValidPairingTopic(n) {
      if (!(0, _utils.isValidString)(n, !1)) {
        var _c28 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(n)),
            e = _c28.message;

        throw new Error(e);
      }

      if (!this.client.core.pairing.pairings.keys.includes(n)) {
        var _c29 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(n)),
            _e2 = _c29.message;

        throw new Error(_e2);
      }

      if ((0, _utils.isExpired)(this.client.core.pairing.pairings.get(n).expiry)) {
        var _c30 = (0, _utils.getInternalError)("EXPIRED", "pairing topic: ".concat(n)),
            _e3 = _c30.message;

        throw new Error(_e3);
      }
    }
  }, {
    key: "isValidSessionTopic",
    value: function () {
      var _isValidSessionTopic = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee50(n) {
        var _c31, e, _c32, _e4, _c33, _e5;

        return _regenerator["default"].wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                if ((0, _utils.isValidString)(n, !1)) {
                  _context50.next = 3;
                  break;
                }

                _c31 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "session topic should be a string: ".concat(n)), e = _c31.message;
                throw new Error(e);

              case 3:
                if (this.client.session.keys.includes(n)) {
                  _context50.next = 6;
                  break;
                }

                _c32 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "session topic doesn't exist: ".concat(n)), _e4 = _c32.message;
                throw new Error(_e4);

              case 6:
                if (!(0, _utils.isExpired)(this.client.session.get(n).expiry)) {
                  _context50.next = 11;
                  break;
                }

                _context50.next = 9;
                return this.deleteSession(n);

              case 9:
                _c33 = (0, _utils.getInternalError)("EXPIRED", "session topic: ".concat(n)), _e5 = _c33.message;
                throw new Error(_e5);

              case 11:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function isValidSessionTopic(_x71) {
        return _isValidSessionTopic.apply(this, arguments);
      }

      return isValidSessionTopic;
    }()
  }, {
    key: "isValidSessionOrPairingTopic",
    value: function () {
      var _isValidSessionOrPairingTopic = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee51(n) {
        var _c34, e, _c35, _e6;

        return _regenerator["default"].wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                if (!this.client.session.keys.includes(n)) {
                  _context51.next = 5;
                  break;
                }

                _context51.next = 3;
                return this.isValidSessionTopic(n);

              case 3:
                _context51.next = 16;
                break;

              case 5:
                if (!this.client.core.pairing.pairings.keys.includes(n)) {
                  _context51.next = 9;
                  break;
                }

                this.isValidPairingTopic(n);
                _context51.next = 16;
                break;

              case 9:
                if (!(0, _utils.isValidString)(n, !1)) {
                  _context51.next = 14;
                  break;
                }

                _c34 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "session or pairing topic doesn't exist: ".concat(n)), e = _c34.message;
                throw new Error(e);

              case 14:
                _c35 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "session or pairing topic should be a string: ".concat(n)), _e6 = _c35.message;
                throw new Error(_e6);

              case 16:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function isValidSessionOrPairingTopic(_x72) {
        return _isValidSessionOrPairingTopic.apply(this, arguments);
      }

      return isValidSessionOrPairingTopic;
    }()
  }, {
    key: "isValidProposalId",
    value: function () {
      var _isValidProposalId = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee52(n) {
        var _c36, e, _c37, _e7, _c38, _e8;

        return _regenerator["default"].wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                if ((0, _utils.isValidId)(n)) {
                  _context52.next = 3;
                  break;
                }

                _c36 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "proposal id should be a number: ".concat(n)), e = _c36.message;
                throw new Error(e);

              case 3:
                if (this.client.proposal.keys.includes(n)) {
                  _context52.next = 6;
                  break;
                }

                _c37 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "proposal id doesn't exist: ".concat(n)), _e7 = _c37.message;
                throw new Error(_e7);

              case 6:
                if (!(0, _utils.isExpired)(this.client.proposal.get(n).expiry)) {
                  _context52.next = 11;
                  break;
                }

                _context52.next = 9;
                return this.deleteProposal(n);

              case 9:
                _c38 = (0, _utils.getInternalError)("EXPIRED", "proposal id: ".concat(n)), _e8 = _c38.message;
                throw new Error(_e8);

              case 11:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function isValidProposalId(_x73) {
        return _isValidProposalId.apply(this, arguments);
      }

      return isValidProposalId;
    }()
  }]);

  return ns;
}(_types.IEngine);

var rs = /*#__PURE__*/function (_K) {
  _inherits(rs, _K);

  var _super2 = _createSuper(rs);

  function rs(n, e) {
    var _this4;

    _classCallCheck(this, rs);

    _this4 = _super2.call(this, n, e, se, b), _this4.core = n, _this4.logger = e;
    return _this4;
  }

  return _createClass(rs);
}(_core.Store);

var os = /*#__PURE__*/function (_K2) {
  _inherits(os, _K2);

  var _super3 = _createSuper(os);

  function os(n, e) {
    var _this5;

    _classCallCheck(this, os);

    _this5 = _super3.call(this, n, e, ie, b), _this5.core = n, _this5.logger = e;
    return _this5;
  }

  return _createClass(os);
}(_core.Store);

var as = /*#__PURE__*/function (_K3) {
  _inherits(as, _K3);

  var _super4 = _createSuper(as);

  function as(n, e) {
    var _this6;

    _classCallCheck(this, as);

    _this6 = _super4.call(this, n, e, re, b, function (s) {
      return s.id;
    }), _this6.core = n, _this6.logger = e;
    return _this6;
  }

  return _createClass(as);
}(_core.Store);

var M = /*#__PURE__*/function (_Se) {
  _inherits(M, _Se);

  var _super5 = _createSuper(M);

  function M(n) {
    var _this7;

    _classCallCheck(this, M);

    _this7 = _super5.call(this, n), _this7.protocol = j, _this7.version = J, _this7.name = G.name, _this7.events = new _events.EventEmitter(), _this7.on = function (s, t) {
      return _this7.events.on(s, t);
    }, _this7.once = function (s, t) {
      return _this7.events.once(s, t);
    }, _this7.off = function (s, t) {
      return _this7.events.off(s, t);
    }, _this7.removeListener = function (s, t) {
      return _this7.events.removeListener(s, t);
    }, _this7.removeAllListeners = function (s) {
      return _this7.events.removeAllListeners(s);
    }, _this7.connect = /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee53(s) {
        return _regenerator["default"].wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.prev = 0;
                _context53.next = 3;
                return _this7.engine.connect(s);

              case 3:
                return _context53.abrupt("return", _context53.sent);

              case 6:
                _context53.prev = 6;
                _context53.t0 = _context53["catch"](0);
                throw _this7.logger.error(_context53.t0.message), _context53.t0;

              case 9:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, null, [[0, 6]]);
      }));

      return function (_x74) {
        return _ref55.apply(this, arguments);
      };
    }(), _this7.pair = /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee54(s) {
        return _regenerator["default"].wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.prev = 0;
                _context54.next = 3;
                return _this7.engine.pair(s);

              case 3:
                return _context54.abrupt("return", _context54.sent);

              case 6:
                _context54.prev = 6;
                _context54.t0 = _context54["catch"](0);
                throw _this7.logger.error(_context54.t0.message), _context54.t0;

              case 9:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, null, [[0, 6]]);
      }));

      return function (_x75) {
        return _ref56.apply(this, arguments);
      };
    }(), _this7.approve = /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee55(s) {
        return _regenerator["default"].wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.prev = 0;
                _context55.next = 3;
                return _this7.engine.approve(s);

              case 3:
                return _context55.abrupt("return", _context55.sent);

              case 6:
                _context55.prev = 6;
                _context55.t0 = _context55["catch"](0);
                throw _this7.logger.error(_context55.t0.message), _context55.t0;

              case 9:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, null, [[0, 6]]);
      }));

      return function (_x76) {
        return _ref57.apply(this, arguments);
      };
    }(), _this7.reject = /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee56(s) {
        return _regenerator["default"].wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.prev = 0;
                _context56.next = 3;
                return _this7.engine.reject(s);

              case 3:
                return _context56.abrupt("return", _context56.sent);

              case 6:
                _context56.prev = 6;
                _context56.t0 = _context56["catch"](0);
                throw _this7.logger.error(_context56.t0.message), _context56.t0;

              case 9:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, null, [[0, 6]]);
      }));

      return function (_x77) {
        return _ref58.apply(this, arguments);
      };
    }(), _this7.update = /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee57(s) {
        return _regenerator["default"].wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _context57.prev = 0;
                _context57.next = 3;
                return _this7.engine.update(s);

              case 3:
                return _context57.abrupt("return", _context57.sent);

              case 6:
                _context57.prev = 6;
                _context57.t0 = _context57["catch"](0);
                throw _this7.logger.error(_context57.t0.message), _context57.t0;

              case 9:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, null, [[0, 6]]);
      }));

      return function (_x78) {
        return _ref59.apply(this, arguments);
      };
    }(), _this7.extend = /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee58(s) {
        return _regenerator["default"].wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.prev = 0;
                _context58.next = 3;
                return _this7.engine.extend(s);

              case 3:
                return _context58.abrupt("return", _context58.sent);

              case 6:
                _context58.prev = 6;
                _context58.t0 = _context58["catch"](0);
                throw _this7.logger.error(_context58.t0.message), _context58.t0;

              case 9:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, null, [[0, 6]]);
      }));

      return function (_x79) {
        return _ref60.apply(this, arguments);
      };
    }(), _this7.request = /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee59(s) {
        return _regenerator["default"].wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.prev = 0;
                _context59.next = 3;
                return _this7.engine.request(s);

              case 3:
                return _context59.abrupt("return", _context59.sent);

              case 6:
                _context59.prev = 6;
                _context59.t0 = _context59["catch"](0);
                throw _this7.logger.error(_context59.t0.message), _context59.t0;

              case 9:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, null, [[0, 6]]);
      }));

      return function (_x80) {
        return _ref61.apply(this, arguments);
      };
    }(), _this7.respond = /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee60(s) {
        return _regenerator["default"].wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.prev = 0;
                _context60.next = 3;
                return _this7.engine.respond(s);

              case 3:
                return _context60.abrupt("return", _context60.sent);

              case 6:
                _context60.prev = 6;
                _context60.t0 = _context60["catch"](0);
                throw _this7.logger.error(_context60.t0.message), _context60.t0;

              case 9:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, null, [[0, 6]]);
      }));

      return function (_x81) {
        return _ref62.apply(this, arguments);
      };
    }(), _this7.ping = /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee61(s) {
        return _regenerator["default"].wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.prev = 0;
                _context61.next = 3;
                return _this7.engine.ping(s);

              case 3:
                return _context61.abrupt("return", _context61.sent);

              case 6:
                _context61.prev = 6;
                _context61.t0 = _context61["catch"](0);
                throw _this7.logger.error(_context61.t0.message), _context61.t0;

              case 9:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, null, [[0, 6]]);
      }));

      return function (_x82) {
        return _ref63.apply(this, arguments);
      };
    }(), _this7.emit = /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee62(s) {
        return _regenerator["default"].wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.prev = 0;
                _context62.next = 3;
                return _this7.engine.emit(s);

              case 3:
                return _context62.abrupt("return", _context62.sent);

              case 6:
                _context62.prev = 6;
                _context62.t0 = _context62["catch"](0);
                throw _this7.logger.error(_context62.t0.message), _context62.t0;

              case 9:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, null, [[0, 6]]);
      }));

      return function (_x83) {
        return _ref64.apply(this, arguments);
      };
    }(), _this7.disconnect = /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee63(s) {
        return _regenerator["default"].wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.prev = 0;
                _context63.next = 3;
                return _this7.engine.disconnect(s);

              case 3:
                return _context63.abrupt("return", _context63.sent);

              case 6:
                _context63.prev = 6;
                _context63.t0 = _context63["catch"](0);
                throw _this7.logger.error(_context63.t0.message), _context63.t0;

              case 9:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, null, [[0, 6]]);
      }));

      return function (_x84) {
        return _ref65.apply(this, arguments);
      };
    }(), _this7.find = function (s) {
      try {
        return _this7.engine.find(s);
      } catch (t) {
        throw _this7.logger.error(t.message), t;
      }
    }, _this7.getPendingSessionRequests = function () {
      try {
        return _this7.engine.getPendingSessionRequests();
      } catch (s) {
        throw _this7.logger.error(s.message), s;
      }
    }, _this7.name = (n === null || n === void 0 ? void 0 : n.name) || G.name, _this7.metadata = (n === null || n === void 0 ? void 0 : n.metadata) || (0, _utils.getAppMetadata)();
    var e = _typeof(n === null || n === void 0 ? void 0 : n.logger) < "u" && typeof (n === null || n === void 0 ? void 0 : n.logger) != "string" ? n.logger : (0, _logger.pino)((0, _logger.getDefaultLoggerOptions)({
      level: (n === null || n === void 0 ? void 0 : n.logger) || G.logger
    }));
    _this7.core = (n === null || n === void 0 ? void 0 : n.core) || new _core.Core(n), _this7.logger = (0, _logger.generateChildLogger)(e, _this7.name), _this7.session = new os(_this7.core, _this7.logger), _this7.proposal = new rs(_this7.core, _this7.logger), _this7.pendingRequest = new as(_this7.core, _this7.logger), _this7.engine = new ns(_assertThisInitialized(_this7));
    return _this7;
  }

  _createClass(M, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "pairing",
    get: function get() {
      return this.core.pairing.pairings;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee64() {
        return _regenerator["default"].wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                this.logger.trace("Initialized");
                _context64.prev = 1;
                _context64.next = 4;
                return this.core.start();

              case 4:
                _context64.next = 6;
                return this.session.init();

              case 6:
                _context64.next = 8;
                return this.proposal.init();

              case 8:
                _context64.next = 10;
                return this.pendingRequest.init();

              case 10:
                _context64.next = 12;
                return this.engine.init();

              case 12:
                this.core.verify.init({
                  verifyUrl: this.metadata.verifyUrl
                });
                this.logger.info("SignClient Initialization Success");
                _context64.next = 19;
                break;

              case 16:
                _context64.prev = 16;
                _context64.t0 = _context64["catch"](1);
                throw this.logger.info("SignClient Initialization Failure"), this.logger.error(_context64.t0.message), _context64.t0;

              case 19:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this, [[1, 16]]);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }], [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee65(n) {
        var e;
        return _regenerator["default"].wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                e = new M(n);
                _context65.next = 3;
                return e.initialize();

              case 3:
                return _context65.abrupt("return", e);

              case 4:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65);
      }));

      function init(_x85) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return M;
}(_types.ISignClient);

exports["default"] = M;
var cs = M;
exports.SignClient = cs;